import moment from "moment";
import React, {useContext, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {isMobile} from "react-device-detect";
import Navbar from "../reusable/navbar";
import PaymentButton from "../common/button/paymentButton";
import EnvelopeBlue from "../common/assets/envelopeBlue.svg";
import CreditCardWhite from "../common/assets/credit-cardWhite.svg";
import ShippingFastBlue from "../common/assets/shipping-fastBlue.svg";
import DownloadBlue from "../common/assets/downloadBlue.svg";
import MoneyIcon from "../common/assets/money-icon.svg";
import Style from "./ticketsDetails.module.scss";
import {useTranslation} from "react-i18next";
import ParkingZoneTextModal from "./parkingZoneTextModal";
import EvidencePhotosModal from "./evidencePhotosModal";
import ObjectionModal from "./objectionModal";
import InfoModal from "./infoModal";
import BankTransferModal from "./bankTransferModal";
import OrderBillModal from "./orderBillModal";
import {RootState} from "../reducers";
import GenericMobileCard from "./general/genericMobileCard";
import TicketDetailsGasStationDesktop from "./TicketDetailsGasStationDesktop";
import TicketDetailsGasStationMobile from "./TicketDetailsGasStationMobile";
import PaidTicketDetails from "./paidTicketDetails";
import TicketDetailsGSPendingDesktop from "./TicketDetailsGSPendingDesktop";
import LoadingIndicator from "../reusable/loadingIndicator";
import {TicketStatus, CountryCode} from "../reducers/ticket";
import {TicketDetailsContext} from "./TicketDetailsContext";
import {getTicket} from "../actions/ticket";
import CancelledTicketDetails from "./cancelledTicketDetails";
import { getZendeskUrl } from "../util/zendeskHelper";
import EvidenceKeyModal from "./evidenceKeyModal";


import { ParkingDurationInfo, extractParkingDurationInfo } from "../util/dataExtraction";

const FINAL_STATUSES: string[] = ["PAID", "STOPPED"];

interface TicketDetailsProps {
  reloadTicket?: boolean;
}

const TiketDetails: React.FC<TicketDetailsProps> = ({ reloadTicket = false }) => {
  const {
    ticket,
    market: countryCode,
    formattedPaidAmount,
    formattedPaidAmountLabel,
    appeal,
    lang,
    formattedTotalAmount,
    formattedAmountLabel,
    payableBeforeMoment,
    setOpenPayment,
    datatransPaymentSuccessffullModalOpen,
    setDatatransPaymentSuccessffullModalOpen,
    datatransPaymentErrorModalOpen,
    setDatatransPaymentErrorModalOpen,
    downloadPaymentSlip,
  } = useContext(TicketDetailsContext);
    const history = useHistory();
    const dispatch = useDispatch();

  useEffect(() => {
    if (reloadTicket && ticket?.number && ticket?.licensePlate) {
      console.log("should reload the ticket");
      dispatch(getTicket({
        number: ticket?.number,
        licensePlate: ticket?.licensePlate
      }, (e) => {}, history));
    }
  }, []);


  if (!ticket || !ticket?.number) {
    history.push({pathname: "/tickets"});
    return null;
  }

  const { isLoading } = useSelector((state: RootState) => state.loader);

  const [images] = useState(() => {
        if (ticket.imageUrls && ticket.imageUrls.length > 0) { // Backend will return imageUrls and videoUrls only with evidence key provided
          const imageUrls = ticket.imageUrls || [];
          const videoUrls = ticket.videoUrls || [];
          return [...imageUrls, ...videoUrls];
        } else {
          return ticket.blurredImageUrls || [];
        }
      });
  const { t, i18n } = useTranslation();
  const [openPZTextModal, setOpenPZTextModal] = useState(false);
  const [openEvidencePhotosModal, setOpenEvidencePhotosModal] = useState(false);
  const [openObjectionModal, setOpenObjectionModal] = useState(false);
  const [openOrderBillModal, setOpenOrderBillModal] = useState(false);
  const [openAlreadyExistMailRequestIn24HoursInfoModal, setOpenAlreadyExistMailRequestIn24HoursInfoModal] = useState(false);
  const [openOrderSlipInfoModal, setOpenOrderSlipInfoModal] = useState(false);
  const [openOrderSlipInfoModalEmail, setOpenOrderSlipInfoModalEmail] = useState(false);
  const [openViolatorAddressDeterminedInfoModal, setOpenViolatorAddressDeterminedInfoModal] = useState(false);
  const [showEvidenceModal, setShowEvidenceModal] = useState(ticket?.hasEvidenceNumber ?? false);
  const [evidenceKey, setEvidenceKey] = useState<string | null>(null);
  const [error, setError] = useState<string>("");

  const [openBankTransferModal, setOpenBankTransferModal] = useState(false);

  const isGasStationTicket = ticket?.gasStationZone != null;
  const isGSPendingTicket = ticket?.gasStationZone == null && ticket?.parkingZone == null;

  const [parkingDurationInfo, setParkingDurationInfo] = useState<ParkingDurationInfo>({
    parkingDurationStart: '',
    parkingDurationEnd: '',
    parkingDurationDuration: ''
  });

  useEffect(() => {
    if (evidenceKey) {
      dispatch(getTicket({
        number: ticket?.number,
        licensePlate: ticket?.licensePlate,
        evidenceKeyNumber: evidenceKey
      }, (e) => {
         setError(e);
         setShowEvidenceModal(true);
      }, history));
      setEvidenceKey(null);
      setShowEvidenceModal(false);
    }
  }, [evidenceKey]);


useEffect(() => {
  if (ticket?.comment) {
    const extracted = extractParkingDurationInfo(ticket.comment);
    setParkingDurationInfo(extracted);
  }
}, [ticket?.comment]);
  useEffect(() => {
      if(["en","de","fr","it"].includes(lang) && ticket?.documentLanguage && ticket.documentLanguage?.toLowerCase() !== lang){
        if(lang !== "en" || ticket.documentLanguage!=="de"){
          localStorage.setItem("beppoSelectedLanguage", String(ticket.documentLanguage));
          i18n.changeLanguage(String(ticket.documentLanguage)).then(() => {
            window.location.reload();
          })
        }
      }
    }, [ticket]);

    useEffect(() => {
      const timeouts: NodeJS.Timeout[] = [];

      if (openViolatorAddressDeterminedInfoModal) {
        const timeout = setTimeout(() => {
          setOpenViolatorAddressDeterminedInfoModal(false);
        }, 15000);
        timeouts.push(timeout);
      }

      if (openOrderSlipInfoModalEmail) {
        const timeout = setTimeout(() => {
          setOpenOrderSlipInfoModalEmail(false);
        }, 4000);
        timeouts.push(timeout);
      }

      if (openOrderSlipInfoModal) {
        const timeout = setTimeout(() => {
          setOpenOrderSlipInfoModal(false);
        }, 4000);
        timeouts.push(timeout);
      }

      if (openAlreadyExistMailRequestIn24HoursInfoModal) {
        const timeout = setTimeout(() => {
          setOpenAlreadyExistMailRequestIn24HoursInfoModal(false);
        }, 20000);
        timeouts.push(timeout);
      }

      return () => {
        timeouts.forEach(clearTimeout);
      };
    }, [
      openViolatorAddressDeterminedInfoModal,
      openOrderSlipInfoModalEmail,
      openOrderSlipInfoModal,
      openAlreadyExistMailRequestIn24HoursInfoModal,
    ]);

  const changeRoute = (path: string) => {
    history.push(path);

  };

  const showParkingDurationData = (durationString?: string): boolean => {
    if (!durationString) return false;

    const match = durationString.match(/\d+/);
    if (!match) return false;

    const minutes = parseInt(match[0], 10);
    return minutes >= 10;
  };
const hasParkingPayDates = (responses: any[]): boolean => {
  if (!Array.isArray(responses)) return false;

  return responses.some((resp: any) =>
    Array.isArray(resp.enforcementItems) &&
    resp.enforcementItems.some((item: any) =>
      Array.isArray(item.infoSections) &&
      item.infoSections.some(
        (section: any) =>
          Array.isArray(section.lines) && section.lines.length > 0
      )
    )
  );
};

const formatStartAndEndParkingPayData = (
  parkingPayDetails: any[] | undefined,
  t: (key: string) => string,
  isMobile: boolean
): JSX.Element | null => {
  if (!parkingPayDetails || !Array.isArray(parkingPayDetails)) return null;

  type Row = { type: "start" | "end"; value: string };
  const rows: Row[] = [];

  const formatDate = (input: string): string => {
    const clean = input.replace(/\s+[–-]\s+/, " ");
    const [date, time] = clean.split(" ");
    const [day, month, year] = date.split(".");
    return `${day}.${month}.${year}/${time}`;
  };

  parkingPayDetails.forEach((detail) => {
    detail?.enforcementItems?.forEach((item: any) => {
      item?.infoSections?.forEach((section: any) => {
        const line = section?.lines?.[0];
        if (!line) return;

        if (section.caption === "Gestartet") {
          rows.push({ type: "start", value: formatDate(line) });
        }

        if (section.caption === "Beendet") {
          rows.push({ type: "end", value: formatDate(line) });
        }
      });
    });
  });

  if (!rows.length) return null;

  // 🔹 MOBILE RENDER
  if (isMobile) {
    return (
      <>
        {rows.map((row, idx) => (
          <div className={Style.formMobile__paragraph} key={idx}>
            <span>
              {row.type === "start"
                ? t("TicketDetails.PaymentsStartDate").toString()
                : t("TicketDetails.PaymentsEndDate").toString()}
            </span>
            <div className={Style.horizontalLine}></div>
            <span className={Style.formMobile__paragraphBold}>{row.value}</span>
          </div>
        ))}
      </>
    );
  }

  // 🔹 DESKTOP / NOT MOBILE RENDER (FULL STRUCTURE YOU REQUESTED)
  return (
    <>
      {rows.map((row, idx) => (
        <div className={Style.detailsContainer} key={idx}>
          <div>
            <span className={Style.detailsContainer__labels}>
              <>
                {row.type === "start"
                  ? t("TicketDetails.PaymentsStartDate").toString()
                  : t("TicketDetails.PaymentsEndDate").toString()}
              </>
            </span>
          </div>

          <div className={Style.horizontalLine}></div>

          <div className={Style.detailsContainer__valueContainer}>
            <span className={Style.detailsContainer__boldValues}>
              {row.value}
            </span>
          </div>
        </div>
      ))}
    </>
  );
};

    const renderContent = () => {
      if (ticket.status === "PAID") {
         return <PaidTicketDetails />;
      }
      if (ticket.status === "STOPPED") {
        return <CancelledTicketDetails />;
      }
      if (isMobile && isGasStationTicket) {
        return <TicketDetailsGasStationMobile />;
      }
      if (isGSPendingTicket) {
        return <TicketDetailsGSPendingDesktop />;
      }

    if (isMobile) {
      return (
        <>
          <GenericMobileCard title={t("TicketDetails.Offense", { context: countryCode })}>
            {isLoading && <LoadingIndicator />}
            <div className={Style.formMobile__paragraph}>
              <span>{t("TicketDetails.Reference number").toString()}</span>
              <div className={Style.horizontalLine}></div>
              <span className={Style.formMobile__paragraphBold}>
                {ticket.number}
              </span>
            </div>
            <div className={Style.formMobile__paragraph}>
              <span>{t<string>("TicketDetails.License plate", { context: countryCode })}</span>
              <div className={Style.horizontalLine}></div>
              <span className={Style.formMobile__paragraphBold}>
                {ticket.licensePlate}
              </span>
            </div>
            <div className={Style.formMobile__paragraph}>
              <span>
                {t("TicketDetails.Place of violation Mobile").toString()}
              </span>
              <div className={Style.horizontalLine}></div>
              <span className={Style.formMobile__paragraphBold}>
                {ticket.address.toString().split(",")[1]}
              </span>
            </div>
            <div className={Style.formMobile__paragraph}>
              <span>{t<string>("TicketDetails.Violation date Mobile")}</span>
              <div className={Style.horizontalLine}></div>
              <span className={Style.formMobile__paragraphBold}>
                {moment(ticket.date).format("DD.MM.YYYY")}
              </span>
            </div>
            <div className={Style.formMobile__paragraph}>
              <span>{t("TicketDetails.Violation time Mobile").toString()}</span>
              <div className={Style.horizontalLine}></div>
              <span className={Style.formMobile__paragraphBold}>
                {moment(ticket.date).format("H:mm")}
              </span>
            </div>
            <div className={Style.formMobile__paragraph}>
              <span>{formattedAmountLabel}</span>
              <div className={Style.horizontalLine}></div>
              <span className={Style.formMobile__paragraphBold}>
                {formattedTotalAmount}
              </span>
            </div>
            {ticket.paidAmount != null && ticket.paidAmount != 0 && <div className={Style.formMobile__paragraph}>
              <span>{formattedPaidAmountLabel}</span>
              <div className={Style.horizontalLine}></div>
              <span className={Style.formMobile__paragraphBold}>
                {formattedPaidAmount}
              </span>
            </div>}
            <div className={Style.formMobile__paragraph}>
              <span>
                {ticket.status === TicketStatus.PAID
                  ? t("TicketDetails.Payment date").toString()
                  : t("TicketDetails.Payable before").toString()}
              </span>
              <div className={Style.horizontalLine}></div>
              <span className={Style.formMobile__paragraphBold}>
                {ticket.status === TicketStatus.PAID
                  ? ticket?.paymentDate
                    ? moment(ticket?.paymentDate).format("DD.MM.YYYY")
                    : "n/a"
                  : payableBeforeMoment}
              </span>
            </div>
            {ticket.parkingPayStatus && <div className={Style.formMobile__paragraph}>
              <span>
                {t("TicketDetails.ParkingPayStatusLabelMobile").toString()}
              </span>
              <div className={Style.horizontalLine}></div>
              <span className={Style.formMobile__paragraphBold}>
                {t(`TicketDetails.${ticket.parkingPayStatus}_MOBILE`)}
              </span>
            </div>}
            {formatStartAndEndParkingPayData(ticket.parkingPayDetails, t, true)}                       
            {showParkingDurationData(parkingDurationInfo.parkingDurationDuration)
                && parkingDurationInfo.parkingDurationStart &&<div className={Style.formMobile__paragraph}>
              <span>{t("TicketDetails.Parking start").toString()}</span>
              <div className={Style.horizontalLine}></div>
              <span className={Style.formMobile__paragraphBold}>
                {parkingDurationInfo.parkingDurationStart}
              </span>
            </div>}
            {showParkingDurationData(parkingDurationInfo.parkingDurationDuration)
                             && parkingDurationInfo.parkingDurationEnd &&<div className={Style.formMobile__paragraph}>
              <span>{t("TicketDetails.Parking end").toString()}</span>
              <div className={Style.horizontalLine}></div>
              <span className={Style.formMobile__paragraphBold}>
                {parkingDurationInfo.parkingDurationEnd}
              </span>
            </div>}
            {showParkingDurationData(parkingDurationInfo.parkingDurationDuration)
                             && parkingDurationInfo.parkingDurationDuration &&<div className={Style.formMobile__paragraph}>
              <span>{t("TicketDetails.Parking duration").toString()}</span>
              <div className={Style.horizontalLine}></div>
              <span className={Style.formMobile__paragraphBold}>
                {parkingDurationInfo.parkingDurationDuration}
              </span>
            </div>}
            {i18n.language === "de" ? (
              <div className={Style.formMobile__paragraphDesc} >
                {t<string>("TicketDetails.Text below.firstPart", { context: countryCode })}
                <span
                  onClick={() => changeRoute("/pz-text")}
                  className={Style.formMobile__mobileLinks}
                >
                  {t("TicketDetails.Text below.secondPart").toString()}
                </span>
                {t<string>("TicketDetails.Text below.thirdPart")}
                <span
                  onClick={() => changeRoute("/evidence")}
                  className={Style.formMobile__mobileLinks}
                >
                  {t("TicketDetails.Text below.fourthPart").toString()}
                </span>
                {t<string>("TicketDetails.Text below.fifthPart")}
                <p></p>
                {!FINAL_STATUSES.includes(ticket.status) ? (
                  <>{t<string>("TicketDetails.Text below.sixthPart", { context: countryCode })}</>
                ) : (
                  <p>
                    <span>
                      {t(
                        "TicketDetails.Text after payment.firstPart"
                      ).toString()}
                    </span>
                    <span>
                      {t(
                        "TicketDetails.Text after payment.secondPart"
                      ).toString()}
                    </span>
                    <span>
                      {t(
                        `TicketDetails.Text after payment.thirdPart.${ticket.status}`
                      ).toString()}
                    </span>
                  </p>
                )}
                {ticket.objectionEnabled &&
                  ticket.status !== TicketStatus.PAID &&
                  !ticket.appeal &&
                  !appeal && (
                    <>
                      {ticket.status === TicketStatus.STOPPED && (
                        <span>
                          {t<string>("TicketDetails.Text below.canceledPartObjection")}
                        </span>
                      )}
                      <span
                          className={Style.formMobile__mobileLinks}
                          onClick={() => window.open(getZendeskUrl(lang), "_blank")}
                        >
                          {t("TicketDetails.Text below.seventhPart")}
                      </span>
                      <span>
                        {t<string>("TicketDetails.Text below.eightPart")}
                      </span>
                    </>
                  )}
              </div>
            ) : (
              <div className={Style.formMobile__paragraphDesc}>
                {t<string>("TicketDetails.Text below.firstPart", { context: countryCode })}
                <span
                  onClick={() => changeRoute("/pz-text")}
                  className={Style.formMobile__mobileLinks}
                >
                  {t<string>("TicketDetails.Text below.secondPart")}
                </span>
                {t<string>("TicketDetails.Text below.thirdPart")}
                <span
                  onClick={() => changeRoute("/evidence")}
                  className={Style.formMobile__mobileLinks}
                >
                  {t<string>("TicketDetails.Text below.fourthPart")}
                </span>
                {t<string>("TicketDetails.Text below.fifthPart")}
                <p></p>
                {!FINAL_STATUSES.includes(ticket.status) ? (
                  <>{t("TicketDetails.Text below.sixthPart", { context: countryCode })}</>
                ) : (
                  <p>
                    <span>
                      {t<string>("TicketDetails.Text after payment.firstPart")}
                    </span>
                    <span>
                      {t<string>("TicketDetails.Text after payment.secondPart")}
                    </span>
                    <span>
                      {t<string>(`TicketDetails.Text after payment.thirdPart.${ticket.status}`)}
                    </span>
                  </p>
                )}
                {ticket.objectionEnabled &&
                  ticket.status !== TicketStatus.PAID &&
                  !ticket.appeal &&
                  !appeal && (
                    <>
                      {ticket.status === TicketStatus.STOPPED && (
                        <span>
                          {t<string>("TicketDetails.Text below.canceledPartObjection")}
                        </span>
                      )}
                      <span
                        className={Style.formMobile__mobileLinks}
                        onClick={() => window.open(getZendeskUrl(lang), "_blank")}
                      >
                        {t("TicketDetails.Text below.seventhPart")}
                      </span>
                      <span>
                        {t<string>("TicketDetails.Text below.eightPart")}
                      </span>
                    </>
                  )}
              </div>
            )}
            {!FINAL_STATUSES.includes(ticket.status) && (
              <>
                <div className={Style.onlinePaymentButtonPosition}>
                  <PaymentButton
                    desktop={false}
                    text={t("TicketDetails.Online payment")}
                    imgSrc={CreditCardWhite}
                    imgAlt="cardWhite"
                    onClick={() => {
                      setOpenPayment(true);
                    }}
                  />
                  <div style={{ flex: 0.05 }}></div>
                  <div
                    className={Style.btnMobilePrimary}
                    onClick={() => changeRoute("/bank-transfer")}
                  >
                    <img src={MoneyIcon} alt="credit-card" />
                    <p className={Style.btnTextWhite}>
                      {t<string>("TicketDetails.BankTransfer")}
                    </p>
                  </div>
                </div>
                <div className={Style.whiteButtonsMobile}>
                  <div
                    className={Style.whiteButtonsMobile__buttonsRowContainer}
                  >
                    <div
                      className={Style.btnMobileWhite}
                      onClick={() => downloadPaymentSlip()}
                    >
                      <img src={DownloadBlue} alt="download" />
                      <p className={Style.btnTextBlue}>
                        {t<string>(
                          "TicketDetails.Download the payment slip mobile"
                        )}
                      </p>
                    </div>
                    <div style={{ flex: 0.05 }}></div>
                    <div
                      className={Style.btnMobileWhite}
                      onClick={() => changeRoute("/order")}
                    >
                      <img src={EnvelopeBlue} alt="shipping-fast" />
                      <p className={Style.btnTextBlue}>
                        {t<string>("TicketDetails.Order a payment slip")}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}


            {datatransPaymentSuccessffullModalOpen && (
              <InfoModal
                open={datatransPaymentSuccessffullModalOpen}
                onClose={setTimeout(() => {
                  setDatatransPaymentSuccessffullModalOpen(false);
                  window.location.replace("/ticket-details");
                }, 5000)}
                title={t("InfoModals.Online payment successfull title")}
                infoText={t("InfoModals.Online payment successfull text")}
              />
            )}

            {datatransPaymentErrorModalOpen && (
              <InfoModal
                open={datatransPaymentErrorModalOpen}
                onClose={setTimeout(() => {
                  setDatatransPaymentErrorModalOpen(false);
                  window.location.replace("/ticket-details");
                }, 5000)}
                title={t("InfoModals.Online payment error title")}
                infoText={t("InfoModals.Online payment error text")}
              />
            )}

            {showEvidenceModal && (
                  <EvidenceKeyModal
                    open={showEvidenceModal}
                    onClose={() => setShowEvidenceModal(false)}
                    onSubmitKey={(key) => {
                      setEvidenceKey(key);
                      console.log("Entered evidence key:", key);
                    }}
                    onContinueWithoutKey={() => {
                      console.log("Continuing without key");
                    }}
                    error={error}
                  />
            )}
          </GenericMobileCard>
        </>
      );
    } else {
      if (isGasStationTicket) {
        return <TicketDetailsGasStationDesktop />;
      } else {
        return (
          <div className={Style.mainContainerDesktop}>
            <Navbar />
            {isLoading && <LoadingIndicator />}
            <div className={Style.formDesktop}>
              <h3 className={Style.formDesktop__subtitle}>
                {t<string>("TicketDetails.Offense", { context: countryCode })}
              </h3>
              <div className={Style.formDesktop__scrollableDiv}>
                <div className={Style.formDesktop__detailsAndImgContainer}>
                  <div className={Style.formDesktop__detailsContainer}>
                    {ticket.ticketViolationType !== "CH_PARKING_VIOLATION_NON_ZPO" && (
                      <p className={Style.formDesktop__paragraph}>
                        {t<string>("TicketDetails.Prohibition offense", { context: countryCode })}
                      </p>
                    )}
                    <div className={Style.detailsContainer}>
                      <div>
                        <span className={Style.detailsContainer__labels}>
                          {t<string>("TicketDetails.Reference number")}
                        </span>
                      </div>
                      <div className={Style.horizontalLine}></div>
                      <div className={Style.detailsContainer__valueContainer}>
                        <span className={Style.detailsContainer__boldValues}>
                          {ticket.number}
                        </span>
                      </div>
                    </div>
                    <div className={Style.detailsContainer}>
                      <div>
                        <span className={Style.detailsContainer__labels}>
                          {t<string>("TicketDetails.License plate", { context: countryCode })}
                        </span>
                      </div>
                      <div className={Style.horizontalLine}></div>
                      <div className={Style.detailsContainer__valueContainer}>
                        <span className={Style.detailsContainer__boldValues}>
                          {ticket.licensePlate}
                        </span>
                      </div>
                    </div>
                    <div className={Style.detailsContainer}>
                      <div>
                        <span className={Style.detailsContainer__labels}>
                          {t<string>("TicketDetails.Place of violation")}
                        </span>
                      </div>
                      <div className={Style.horizontalLine}></div>
                      <div className={Style.detailsContainer__valueContainer}>
                        <span className={Style.detailsContainer__boldValues}>
                          {ticket.address}
                        </span>
                      </div>
                    </div>
                    <div className={Style.detailsContainer}>
                      <div>
                        <span className={Style.detailsContainer__labels}>
                          {t<string>("TicketDetails.Violation date")}
                        </span>
                      </div>
                      <div className={Style.horizontalLine}></div>
                      <div className={Style.detailsContainer__valueContainer}>
                        <span className={Style.detailsContainer__boldValues}>
                          {moment(ticket.date).format("DD.MM.YYYY")}
                        </span>
                      </div>
                    </div>
                    <div className={Style.detailsContainer}>
                      <div>
                        <span className={Style.detailsContainer__labels}>
                          {t<string>("TicketDetails.Violation time")}
                        </span>
                      </div>
                      <div className={Style.horizontalLine}></div>
                      <div className={Style.detailsContainer__valueContainer}>
                        <span className={Style.detailsContainer__boldValues}>
                          {moment(ticket.date).format("HH:mm")}{" "}
                        </span>
                      </div>
                    </div>
                    <div className={Style.detailsContainer}>
                      <div>
                        <span className={Style.detailsContainer__labels}>
                          {formattedAmountLabel}
                        </span>
                      </div>
                      <div className={Style.horizontalLine}></div>
                      <div className={Style.detailsContainer__valueContainer}>
                        <span className={Style.detailsContainer__boldValues}>
                          {formattedTotalAmount}
                        </span>
                      </div>
                    </div>
                    {ticket.paidAmount != null && ticket.paidAmount != 0 && <div className={Style.detailsContainer}>
                  <div>
                    <span className={Style.detailsContainer__labels}>
                      {formattedPaidAmountLabel}
                    </span>
                  </div>
                  <div className={Style.horizontalLine}></div>
                  <div className={Style.detailsContainer__valueContainer}>
                    <span className={Style.detailsContainer__boldValues}>
                      {formattedPaidAmount}
                    </span>
                  </div>
                </div>}                        
                    <div className={Style.detailsContainer}>
                      <div>
                        <span className={Style.detailsContainer__labels}>
                          <>
                            {ticket.status === TicketStatus.PAID
                              ? t("TicketDetails.Payment date")
                              : t("TicketDetails.Payable before")}
                          </>
                        </span>
                      </div>
                      <div className={Style.horizontalLine}></div>
                      <div className={Style.detailsContainer__valueContainer}>
                        <span className={Style.detailsContainer__boldValues}>
                          {ticket.status === TicketStatus.PAID
                            ? moment(ticket?.paymentDate).format("DD.MM.YYYY")
                            : payableBeforeMoment}
                        </span>
                      </div>
                    </div>

                    {ticket.parkingPayStatus && <div className={Style.detailsContainer}>
                      <div>
                        <span className={Style.detailsContainer__labels}>
                          <>
                            {t("TicketDetails.ParkingPayStatusLabel")}
                          </>
                        </span>
                      </div>
                      <div className={Style.horizontalLine}></div>
                      <div className={Style.detailsContainer__valueContainer}>
                        <span className={Style.detailsContainer__boldValues}>
                            {t(`TicketDetails.${ticket.parkingPayStatus}`)}
                        </span>
                      </div>
                    </div>}                    
                    {formatStartAndEndParkingPayData(ticket.parkingPayDetails, t, false)}                         
                    {showParkingDurationData(parkingDurationInfo.parkingDurationDuration)
                                     && parkingDurationInfo.parkingDurationStart &&<div className={Style.detailsContainer}>
                      <div>
                        <span className={Style.detailsContainer__labels}>
                          {t<string>("TicketDetails.Parking start")}
                        </span>
                      </div>
                      <div className={Style.horizontalLine}></div>
                      <div className={Style.detailsContainer__valueContainer}>
                        <span className={Style.detailsContainer__boldValues}>
                          {parkingDurationInfo.parkingDurationStart}
                        </span>
                      </div>
                    </div>}
                    {showParkingDurationData(parkingDurationInfo.parkingDurationDuration)
                                     && parkingDurationInfo.parkingDurationEnd &&<div className={Style.detailsContainer}>
                      <div>
                        <span className={Style.detailsContainer__labels}>
                          {t<string>("TicketDetails.Parking end")}
                        </span>
                      </div>
                      <div className={Style.horizontalLine}></div>
                      <div className={Style.detailsContainer__valueContainer}>
                        <span className={Style.detailsContainer__boldValues}>
                          {parkingDurationInfo.parkingDurationEnd}
                        </span>
                      </div>
                    </div>}
                    {showParkingDurationData(parkingDurationInfo.parkingDurationDuration)
                                     && parkingDurationInfo.parkingDurationDuration && <div className={Style.detailsContainer}>
                      <div>
                        <span className={Style.detailsContainer__labels}>
                          {t<string>("TicketDetails.Parking duration")}
                        </span>
                      </div>
                      <div className={Style.horizontalLine}></div>
                      <div className={Style.detailsContainer__valueContainer}>
                        <span className={Style.detailsContainer__boldValues}>
                          {parkingDurationInfo.parkingDurationDuration}
                        </span>
                      </div>
                    </div>}

                  </div>
                  <div className={Style.detailsAndImgContainer__imgContainer}>
                    <img src={images[0]} alt="" height={"100%"}
                         onClick={() => {
                           setOpenEvidencePhotosModal(true);
                         }}
                         className={Style.formDesktop__links}
                    />
                  </div>
                </div>
                <p></p>
                {i18n.language === "de" ? (
                  <div className={Style.formDesktop__paragraph}>
                    {t<string>("TicketDetails.Text below.firstPart", { context: countryCode })}
                    <span
                      onClick={() => {
                        setOpenPZTextModal(true);
                      }}
                      className={Style.formDesktop__links}
                    >
                      {t<string>("TicketDetails.Text below.secondPart")}
                    </span>
                    {t<string>("TicketDetails.Text below.thirdPart")}
                    <span
                      onClick={() => {
                        setOpenEvidencePhotosModal(true);
                      }}
                      className={Style.formDesktop__links}
                    >
                      {t<string>("TicketDetails.Text below.fourthPart")}
                    </span>
                    {t<string>("TicketDetails.Text below.fifthPart")}
                    <p></p>
                    <p>
                      {!FINAL_STATUSES.includes(ticket.status) ? (
                        <>{t("TicketDetails.Text below.sixthPart", { context: countryCode })}</>
                      ) : (
                        <p>
                          <span>
                            {t<string>(
                              "TicketDetails.Text after payment.firstPart"
                            )}
                          </span>
                          <span>
                            {t<string>(
                              "TicketDetails.Text after payment.secondPart"
                            )}
                          </span>
                          <span>
                            {t<string>(
                              `TicketDetails.Text after payment.thirdPart.${ticket.status}`
                            )}
                          </span>
                        </p>
                      )}
                      {ticket.objectionEnabled &&
                        ticket.status !== TicketStatus.PAID &&
                        !ticket.appeal &&
                        !appeal && (
                          <>
                          {ticket.status === TicketStatus.STOPPED && (
                            <span>
                              {t<string>("TicketDetails.Text below.canceledPartObjection")}
                            </span>
                          )}
                            <span
                              className={Style.formDesktop__links}
                              onClick={() => window.open(getZendeskUrl(lang), "_blank")}
                            >
                              {t("TicketDetails.Text below.seventhPart")}
                            </span>
                            <span>
                              {t<string>("TicketDetails.Text below.eightPart")}
                            </span>
                          </>
                        )}
                    </p>
                  </div>
                ) : (
                  <div className={Style.formDesktop__paragraph}>
                    {t<string>("TicketDetails.Text below.firstPart", { context: countryCode })}
                    <span
                      onClick={() => {
                        setOpenPZTextModal(true);
                      }}
                      className={Style.formDesktop__links}
                    >
                      {t<string>("TicketDetails.Text below.secondPart")}
                    </span>
                    {t<string>("TicketDetails.Text below.thirdPart")}
                    <span
                      onClick={() => {
                        setOpenEvidencePhotosModal(true);
                      }}
                      className={Style.formDesktop__links}
                    >
                      {t<string>("TicketDetails.Text below.fourthPart")}
                    </span>
                    {t<string>("TicketDetails.Text below.fifthPart")}
                    <p></p>
                    <p>
                      {!FINAL_STATUSES.includes(ticket.status) ? (
                        <>{t("TicketDetails.Text below.sixthPart", { context: countryCode })}</>
                      ) : (
                        <p>
                          <span>
                            {t<string>(
                              "TicketDetails.Text after payment.firstPart"
                            )}
                          </span>
                          <span>
                            {t<string>(
                              "TicketDetails.Text after payment.secondPart"
                            )}
                          </span>
                          <span>
                            {t<string>(
                              `TicketDetails.Text after payment.thirdPart.${ticket.status}`
                            )}
                          </span>
                        </p>
                      )}
                      {ticket.objectionEnabled &&
                        ticket.status !== TicketStatus.PAID &&
                        !ticket.appeal &&
                        !appeal && (
                          <>
                            {ticket.status === TicketStatus.STOPPED && (
                              <span>
                                {t<string>("TicketDetails.Text below.canceledPartObjection")}
                              </span>
                            )}
                            <span
                              className={Style.formDesktop__links}
                              onClick={() => window.open(getZendeskUrl(lang), "_blank")}
                            >
                              {t("TicketDetails.Text below.seventhPart")}
                            </span>
                            <span>
                              {t<string>("TicketDetails.Text below.eightPart")}
                            </span>
                          </>
                        )}
                    </p>
                  </div>
                )}
              </div>
              {!FINAL_STATUSES.includes(ticket.status) && (
                <>
                  <div>
                    <div className={Style.formDesktop__fourButtonsContainer}>
                      <div style={{ display: "flex", flex: 1 }}>
                        <div
                          className={Style.btnPrimary}
                          onClick={() => {
                            setOpenBankTransferModal(true);
                          }}
                        >
                          <img
                            src={MoneyIcon}
                            alt="cardWhite"
                            className={
                              Style.formDesktop__fourButtonsContainer__imgDesktop
                            }
                          />
                          <p
                            className={
                              Style.formDesktop__fourButtonsContainer__buttonTextWhite
                            }
                          >
                            {t<string>("TicketDetails.BankTransfer")}
                          </p>
                        </div>
                        <div style={{ flex: 0.1 }}></div>
                        <PaymentButton
                          text={t("TicketDetails.Online payment")}
                          desktop
                          imgSrc={CreditCardWhite}
                          imgAlt="cardWhite"
                          onClick={() => {
                            setOpenPayment(true);
                          }}
                        />
                      </div>
                      <div
                        className={
                          Style.formDesktop__fourButtonsContainer__whiteBtnMargin
                        }
                      ></div>
                      <div style={{ display: "flex", flex: 1 }}>
                        <div
                          className={Style.btnWhite}
                          onClick={() => downloadPaymentSlip()}
                        >
                          <img
                            src={DownloadBlue}
                            alt="downloadBlue"
                            className={
                              Style.formDesktop__fourButtonsContainer__icon
                            }
                          />
                          <p className={Style.btnTextBlue}>
                            {t<string>(
                              "TicketDetails.Download the payment slip"
                            )}
                          </p>
                        </div>
                        <div style={{ flex: 0.1 }}></div>
                        <div
                          className={Style.btnWhite}
                          onClick={() => {
                            setOpenOrderBillModal(true);
                          }}
                        >
                          <img
                            src={ShippingFastBlue}
                            alt="fastBlue"
                            className={
                              Style.formDesktop__fourButtonsContainer__icon
                            }
                          />
                          <p className={Style.btnTextBlue}>
                            {t<string>("TicketDetails.Order a payment slip")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            {openPZTextModal && (
              <ParkingZoneTextModal
                open={openPZTextModal}
                value={ticket.parkingZone.parkingZoneText}
                onClose={() => setOpenPZTextModal(false)}
                title={t("TicketDetails.parkingZoneText")}
              />
            )}
            {openEvidencePhotosModal && (
              <EvidencePhotosModal
                open={openEvidencePhotosModal}
                onClose={() => setOpenEvidencePhotosModal(false)}
                title={t("TicketDetails.Photos")}
              />
            )}
            {openObjectionModal && (
              <ObjectionModal
                open={openObjectionModal}
                onClose={() => setOpenObjectionModal(false)}
                title={t("TicketDetails.Objection")}
              />
            )}
            {openOrderBillModal && (
              <OrderBillModal
                open={openOrderBillModal}
                onClose={() => setOpenOrderBillModal(false)}
                openInfoModal={() => setOpenOrderSlipInfoModal(true)}
                openInfoModalEmail={() => setOpenOrderSlipInfoModalEmail(true)}
                openViolatorAddressDeterminedInfoModal={() => setOpenViolatorAddressDeterminedInfoModal(true)}
                openAlreadyExistMailRequestIn24HoursInfoModal={() => setOpenAlreadyExistMailRequestIn24HoursInfoModal(true)}
                title={t("Order.Order a payment slip")}
              />
            )}
            {openOrderSlipInfoModal && (
              <InfoModal
                open={openOrderSlipInfoModal}
                onClose={() => setOpenOrderSlipInfoModal(false)}
                title={t("InfoModals.Invoice order title")}
                infoText={t("InfoModals.Invoice order text")}
              />
            )}
            {openAlreadyExistMailRequestIn24HoursInfoModal && (
              <InfoModal
                open={openAlreadyExistMailRequestIn24HoursInfoModal}
                onClose={() => setOpenAlreadyExistMailRequestIn24HoursInfoModal(false)}
                title={t("InfoModals.mailRequestAlreadyExists.title")}
                infoText={t("InfoModals.mailRequestAlreadyExists.text")}
              />
            )}
            {openOrderSlipInfoModalEmail && (
              <InfoModal
                open={openOrderSlipInfoModalEmail}
                onClose={() => setOpenOrderSlipInfoModalEmail(false)}
                title={t("InfoModals.Invoice order via email title")}
                infoText={t("InfoModals.Invoice order via email text")}
              />
            )}
            {openViolatorAddressDeterminedInfoModal && (
              <InfoModal
                open={openViolatorAddressDeterminedInfoModal}
                onClose={() => setOpenViolatorAddressDeterminedInfoModal(false)}
                title={t("InfoModals.Invoice order determined address title")}
                infoText={t("InfoModals.Invoice order determined address text")}
              />
            )}
            {openBankTransferModal && (
              <BankTransferModal
                open={openBankTransferModal}
                onClose={() => setOpenBankTransferModal(false)}
                title={t("TicketDetails.BankTransfer")}
                totalAmount={formattedTotalAmount}
              />
            )}

            {datatransPaymentSuccessffullModalOpen && (
              <InfoModal
                open={datatransPaymentSuccessffullModalOpen}
                onClose={setTimeout(() => {
                  setDatatransPaymentSuccessffullModalOpen(false);
                  window.location.replace("/ticket-details");
                }, 5000)}
                title={t("InfoModals.Online payment successfull title")}
                infoText={t("InfoModals.Online payment successfull text")}
              />
            )}

            {datatransPaymentErrorModalOpen && (
              <InfoModal
                open={datatransPaymentErrorModalOpen}
                onClose={setTimeout(() => {
                  setDatatransPaymentErrorModalOpen(false);
                  window.location.replace("/ticket-details");
                }, 5000)}
                title={t("InfoModals.Online payment error title")}
                infoText={t("InfoModals.Online payment error text")}
              />
            )}
            {showEvidenceModal && (
               <EvidenceKeyModal
                 open={showEvidenceModal}
                 onClose={() => setShowEvidenceModal(false)}
                 onSubmitKey={(key) => {
                   setEvidenceKey(key);
                   console.log("Entered evidence key:", key);
                 }}
                 onContinueWithoutKey={() => {
                   console.log("Continuing without key");
                 }}
                 error={error}
               />
            )}
          </div>
        );
      }
    }
  };

  return (
      <div className="ticket-details-container">
        {isLoading &&
            <div className={Style.loadingOverlay}>
              <LoadingIndicator/>
            </div>
        }
        {renderContent()}
      </div>
  );
};

export default TiketDetails;
